"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var WrappedPropertyArrayItem_1 = require("./WrappedPropertyArrayItem");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var WrappedPropertyArrayItemDirect_1 = require("./WrappedPropertyArrayItemDirect");
var fixData_1 = require("../JSchema/fixData");
var calcFunction_1 = require("../JSchema/calcFunction");
var aggregateFunction_1 = require("../JSchema/aggregateFunction");
var setData_1 = require("../JSchema/setData");
var defaultValue_1 = require("../JSchema/defaultValue");
var WrappedPropertyArray = /** @class */ (function (_super) {
    __extends(WrappedPropertyArray, _super);
    function WrappedPropertyArray(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        var internal = _this._internal;
        _this._internal.mparent = _this.$model;
        _this._internal.schitems = schema.items;
        // internal.subitemcache = [];
        _this._internal.cachedKey = '';
        _this._internal.cachedItems = [];
        _this._internal.mparent = _this.$model;
        // //export const wrapSchemaProps = ['maxLength', 'minLength', 'maxItems', 'minItems', 'minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum', 'precision'];
        functions_1.wrapSchemaProps(_this.$schema, internal, 'number', ['maxItems', 'minItems']);
        // tworzenie tablicy
        var mlength = internal.mparent.length;
        _this._internal.ntable = new Array(mlength);
        // console.time('addRows wrapall:' + internal.options.wrapAll + ' (' + mlength + ')');
        // if (internal.options.wrapAll) {
        if (false) {
            for (var i = 0; i < mlength; i++) {
                // const ssubitem = new WrapperPropertyArrayItem(self, internal.mparent, rowIndex, schitems, internal.options);
                // internal.ntable.push(new WrapperPropertyArrayItem(this, internal.mparent, i, internal.schitems, internal.options));
                internal.ntable[i] = new WrappedPropertyArrayItemDirect_1.WrapperPropertyArrayItemDirect(_this, internal.mparent, i, internal.schitems, internal.options);
                // addRow(this, internal, internal.schitems, i);
            }
        }
        else {
            for (var i = 0; i < mlength; i++) {
                // const ssubitem = new WrapperPropertyArrayItem(self, internal.mparent, rowIndex, schitems, internal.options);
                // internal.ntable.push(new WrapperPropertyArrayItem(this, internal.mparent, i, internal.schitems, internal.options));
                internal.ntable[i] = new WrappedPropertyArrayItem_1.WrapperPropertyArrayItem(_this, internal.mparent, i, internal.schitems, internal.options);
                // return ssubitem as IWrapperPropertyArrayItem;
                // addRow(this, internal, internal.schitems, i);
            }
        }
        // length
        if (schema.length !== undefined) {
            if (typeof schema.length !== 'number') {
                functions_1.wrapSchemaProp(_this.$schema, 'length', internal, function (newValue) { return _this.$setLength(newValue); });
            }
            else {
                _this.$schema.length = schema.length;
                _this.$setLength(schema.length);
            }
        }
        // console.timeEnd('addRows wrapall:' + internal.options.wrapAll + ' (' + mlength + ')');
        // computed
        var self = _this;
        internal.useComputedModel = true;
        internal.computed.items = function () {
            var smodel = parent[propName];
            var l = smodel.length;
            // console.log('mparent.length', mparent.length);
            if (l > internal.ntable.length) {
                // console.log('autogrow', l, ntable.length);
                while (internal.ntable.length < l) {
                    fixData_1.default(internal.schitems, smodel[internal.ntable.length], options.Vue);
                    addRow(_this, internal, internal.schitems, internal.ntable.length);
                }
            }
            else if (l < internal.ntable.length) {
                clearCached(internal);
                internal.ntable.length = l;
            }
            return internal.ntable;
            // return [];
        };
        internal.watch.items = {
            // deep,
            handler: function (newValue) {
                if (schema.debug) {
                    debugger;
                }
                self.$dirty = true;
                // self.$validate(parent[propName]);
            }
        };
        // potrzebne przeliczenia na starcie
        if (mlength && !self._options.disableCalculations && !self._options.wrapAll) {
            var needCalc = functions_1.anyCalc(internal.schitems);
            var props = internal.schitems.properties;
            if (needCalc && props) {
                // są jakieś pola wymagające kalkulacji
                // $root,$parent,$parent2,$parent3,$external,$methods,$obj
                var paramdata = [_this.$root.$model, internal.mparent, {}, {}, options.external, options.schemaMethods, , null];
                if (dest) {
                    paramdata[2] = dest.$model;
                    if (dest.$parent) {
                        paramdata[3] = dest.$parent.$model;
                    }
                }
                //  let props = schitems.properties;
                for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
                    var schkey = _a[_i];
                    var schitem = props[schkey];
                    if (schitem.calc) {
                        var stime = new Date().getTime();
                        var calcFunc = calcFunction_1.default(schitem, true);
                        var $mparent = {
                            $parent: self,
                            $key: 0
                        };
                        paramdata[6] = { $key: schkey, $parent: $mparent };
                        try {
                            // for (let i = 0; i < mlength; i++) {
                            //  paramdata[6].$parent.$key = i;
                            for (; $mparent.$key < mlength; $mparent.$key++) {
                                var res = calcFunc.apply(internal.mparent[$mparent.$key], paramdata);
                                if (res !== undefined) {
                                    options.Vue.set(internal.mparent[$mparent.$key], schkey, res);
                                }
                                // mparent[$mparent.$key][schkey] = calcFunc.apply(mparent[$mparent.$key], paramdata);
                            }
                        }
                        catch (err) {
                            if (process.env.NODE_ENV === 'development') {
                                console.error('ERR calc:model result', err);
                            }
                            // moze się wywalić wiec spokojnie
                            continue;
                        }
                        // console.log(`calc ${schkey} in ${propName}[${mlength}]`, new Date().getTime() - stime);
                    }
                    else if (schitem.aggregate) {
                        if (process.env.NODE_ENV === 'development') {
                            console.time('agg:model ' + self.$path + '[].' + schkey);
                            // console.info('agg:model', new Date().getTime() - stime);
                        }
                        var stime = new Date().getTime();
                        var aggFunc = aggregateFunction_1.default(schitem, true);
                        var $mparent = {
                            $parent: self,
                            $key: 0
                        };
                        paramdata[6] = { $key: schkey, $parent: $mparent };
                        try {
                            // for (let i = 0; i < mlength; i++) {
                            //  paramdata[6].$parent.$key = i;
                            for (; $mparent.$key < mlength; $mparent.$key++) {
                                var res = aggFunc.apply(internal.mparent[$mparent.$key], paramdata);
                                // mparent[$mparent.$key][schkey] = res;
                                if (res !== undefined) {
                                    options.Vue.set(internal.mparent[$mparent.$key], schkey, res);
                                }
                                // mparent[$mparent.$key][schkey] = calcFunc.apply(mparent[$mparent.$key], paramdata);
                            }
                            if (process.env.NODE_ENV === 'development') {
                                console.timeEnd('agg:model ' + self.$path + '[].' + schkey);
                                //  console.info('agg:model', new Date().getTime() - stime);
                            }
                        }
                        catch (err) {
                            if (process.env.NODE_ENV === 'development') {
                                console.warn('agg:model rerror', err);
                                console.timeEnd('agg:model ' + self.$path + '[].' + schkey);
                            }
                            // moze się wywalić wiec spokojnie
                            continue;
                        }
                    }
                    // if (schitems.calc) || (schitem.summary) || (schitem.agg)
                }
            }
        }
        functions_1.initVue(_this, _this._internal);
        return _this;
        // już po stworzeniu Vue
        // this._options.Vue.set(this.$data, 'order', '');
        // this.$setUserData('order', '');
    }
    WrappedPropertyArray.prototype.$validate = function (value) {
        if (value === undefined) {
            value = this.$model;
        }
        if (value === undefined || value === null) {
            if (this.$schema.fieldRequired) {
                return functions_1.getRuleMessage(this._internal, 'required', value, this.$schema);
            }
            else {
                return null;
            }
        }
        return _super.prototype.$validate.call(this, value);
    };
    WrappedPropertyArray.prototype.$validateAll = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$validate() !== null) {
            result.push(this);
        }
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$item.$validateAll(result);
        }
        return result;
    };
    WrappedPropertyArray.prototype.$setData = function (value, path, fixArraySize) {
        // /Vue.set(parent, propName, value);
        return setData_1.default(this._internal.schema, this.$model, value, path, 0, this._options.Vue, fixArraySize);
    };
    WrappedPropertyArray.prototype.$reset = function () {
        /*
    for (let i = 0; i < this.internal.mparent.length; i++) {
    const subitem = this.internal.subitemcache[i];
    if (subitem !== undefined) {
    subitem.$reset();
    }
    }
    */
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$reset();
        }
        _super.prototype.$reset.call(this);
        // this.$dirty = false;
        // this.internal.vm.error = null;
    };
    WrappedPropertyArray.prototype.$dirtyList = function (result) {
        if (result === undefined) {
            result = [];
        }
        for (var i = 0; i < this._internal.ntable.length; i++) {
            this._internal.ntable[i].$dirtyList(result);
        }
        /*
    
    for (let i = 0; i < this.internal.mparent.length; i++) {
    const subitem = this.internal.subitemcache[i];
    if (subitem !== undefined) {
    subitem.$dirtyList(result);
    }
    }
    */
        return result;
    };
    Object.defineProperty(WrappedPropertyArray.prototype, "$items", {
        get: function () {
            if (this._internal.vm) {
                return this._internal.vm.items;
            }
            else {
                return this._internal.ntable;
            }
        },
        enumerable: true,
        configurable: true
    });
    WrappedPropertyArray.prototype.$setLength = function (newLength) {
        var stable = this.$model;
        if (stable.length !== newLength) {
            while (stable.length > newLength) {
                this.$removeRow(stable.length - 1);
            }
            while (stable.length < newLength) {
                // obj.$addRow(undefined, 1);
                this.$addRow(undefined, newLength - stable.length);
            }
        }
        return true;
    };
    WrappedPropertyArray.prototype.$addRow = function (nvalue, count) {
        if (count === void 0) { count = 1; }
        var mparent2 = this.$model;
        if (mparent2 === undefined) {
            // Vue.set(parent, propName, []);
            var defvalue = defaultValue_1.default(this._internal.schema, true);
            // console.log('recreate array',propName,defvalue);
            this.$setData(defvalue);
            // this.internal.Vue.set(this.internal.parent, this.propName, defvalue);
            mparent2 = this.$model;
        }
        // gdy jest ustawiona stała długość
        if (this.$schema.length !== undefined && mparent2.length === this.$schema.length) {
            return false;
        }
        this._internal.cachedKey = '';
        var startindex = mparent2.length;
        var schitems = this._internal.schitems;
        var nvalue2;
        if (schitems.type === 'object') {
            for (var i = 0; i < count; i++) {
                nvalue2 = defaultValue_1.default(schitems, true);
                if (nvalue) {
                    nvalue2 = Object.assign(nvalue2, nvalue);
                }
                mparent2.push(nvalue2);
            }
        }
        else {
            for (var i = 0; i < count; i++) {
                if (nvalue !== undefined) {
                    nvalue2 = nvalue;
                }
                else {
                    nvalue2 = defaultValue_1.default(schitems, true);
                }
                this._options.Vue.set(mparent2, startindex + i, nvalue2);
                if (process.env.NODE_ENV === 'development') {
                    console.log('vue set array item', startindex, nvalue2, mparent2.length);
                }
            }
        }
        for (var i = 0; i < count; i++) {
            addRow(this, this._internal, schitems, startindex + i);
        }
        return true;
    };
    WrappedPropertyArray.prototype.$removeRow = function (index) {
        if (process.env.NODE_ENV === 'development') {
            console.time('$removeRow');
        }
        var modeltable = this.$model;
        // schematable.splice(index, 1);
        if (this.$schema.length !== undefined && modeltable.length === this.$schema.length) {
            return false;
        }
        this._internal.cachedKey = '';
        this._internal.ntable.splice(index, 1);
        var l = this._internal.ntable.length;
        for (var i = index; i < l; i++) {
            this._internal.ntable[i].$setKey(i);
        }
        /*
    this.internal.subitemcache.splice(index, 1);
    for (let i = index; i < l; i++) {
    this.internal.ntable[i].$key = i;
    if (this.internal.subitemcache[i] !== undefined) {
    this.internal.subitemcache[i].$key = i;
    }
    }
    */
        modeltable.splice(index, 1); // bo na tym jest event ?
        if (process.env.NODE_ENV === 'development') {
            console.timeEnd('$removeRow');
        }
        return true;
    };
    WrappedPropertyArray.prototype.$clearRow = function (index) {
        var nitem = defaultValue_1.default(this._internal.schema);
        this._internal.ntable[index].$clearCache();
        /*
    if (this.internal.subitemcache[index] !== undefined) {
    this.internal.subitemcache[index].$destroy();
    this.internal.subitemcache[index] = undefined;
    }
    */
        this._options.Vue.set(this.$model, index, nitem);
        return true;
    };
    WrappedPropertyArray.prototype.$exchangeRow = function (index1, index2) {
        this._internal.cachedKey = '';
        if (process.env.NODE_ENV === 'development') {
            console.time("$exchangeRow(" + index1 + "," + index2 + ")");
        }
        var mparent = this.$model;
        var item1 = mparent[index1];
        var item2 = mparent[index2];
        this._internal.ntable[index1].$clearCache();
        this._internal.ntable[index2].$clearCache();
        /*
    if (this.internal.subitemcache[index1] !== undefined) {
    this.internal.subitemcache[index1].$destroy();
    this.internal.subitemcache[index1] = undefined;
    }
    if (this.internal.subitemcache[index2] !== undefined) {
    this.internal.subitemcache[index2].$destroy();
    this.internal.subitemcache[index2] = undefined;
    }
    */
        this._options.Vue.set(mparent, index1, item2);
        this._options.Vue.set(mparent, index2, item1);
        // mparent[index1] = item2;
        // mparent[index2] = item1;
        if (process.env.NODE_ENV === 'development') {
            console.timeEnd("$exchangeRow(" + index1 + "," + index2 + ")");
        }
        return true;
        // console.log('exchanged', index1, index2);
    };
    WrappedPropertyArray.prototype.$moveUp = function (index) {
        if (index > 0) {
            return this.$exchangeRow(index, index - 1);
        }
        return false;
    };
    WrappedPropertyArray.prototype.$moveDown = function (index) {
        if (index < this.$model.length - 1) {
            return this.$exchangeRow(index, index + 1);
        }
        return false;
    };
    WrappedPropertyArray.prototype.$sort = function (field) {
        // let stime = new Date().getTime();
        if (process.env.NODE_ENV === 'development') {
            console.time("$sort(" + this.$key + "," + field + ")");
        }
        this._internal.cachedKey = '';
        var mparent = (this._internal.mparent = this._internal.mparent.sort(function (a, b) { return (b[field] === a[field] ? 0 : b[field] > a[field] ? -1 : 1); }));
        // mparent = parent[propName] = narray;
        // destroy
        // clearCached();
        var index = this._internal.ntable.length;
        while (index--) {
            this._internal.ntable[index].$clearCache();
        }
        if (process.env.NODE_ENV === 'development') {
            console.timeEnd("$sort(" + this.$key + "," + field + ")");
            console.log("   [0]." + field + "=" + mparent[0][field] + (", [" + (mparent.length - 1) + "]." + field) + ("=" + mparent[mparent.length - 1][field]));
        }
        // tslint:disable-next-line: max-line-length
        // console.log('sorting', propName, field, new Date().getTime() - stime, mparent[0][field], mparent[mparent.length - 1][field]);
    };
    WrappedPropertyArray.prototype.$filter = function (func) {
        if (func) {
            return this._internal.ntable.filter(func);
        }
        return this._internal.ntable;
    };
    Object.defineProperty(WrappedPropertyArray.prototype, "pageNumber", {
        get: function () {
            return this.$getUserData('pageNumber', 0);
            // return this.$data.pageNumber || 0;
        },
        set: function (newValue) {
            if (newValue < 0) {
                this.$setUserData('pageNumber', 0);
                // this._options.Vue.set(this.$data, 'pageNumber', 0);
            }
            else if (newValue >= this.pageCount) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('overflow pagenumber', newValue, this.pageCount - 1);
                }
                this.$setUserData('pageNumber', this.pageCount - 1);
                // this._options.Vue.set(this.obj.$data, 'pageNumber', this.pageCount - 1);
            }
            else {
                this.$setUserData('pageNumber', newValue);
                // this._options.Vue.set(this.obj.$data, 'pageNumber', newValue);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyArray.prototype, "pageSize", {
        get: function () {
            return this.$getUserData('pageSize', 25);
            // return this.$data.pageSize;
        },
        set: function (newValue) {
            this.$setUserData('pageSize', newValue);
            // this._options.Vue.set(this.$data, 'pageSize', newValue);
            if (this.pageNumber >= this.pageCount) {
                this.pageNumber = this.pageCount - 1;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyArray.prototype, "pageCount", {
        get: function () {
            return Math.ceil(this.$model.length / this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyArray.prototype, "order", {
        get: function () {
            return this.$getUserData('order', '');
        },
        set: function (newValue) {
            this.$setUserData('order', newValue);
            // this._options.Vue.set(this.$data, 'order', newValue);
        },
        enumerable: true,
        configurable: true
    });
    WrappedPropertyArray.prototype.$getItems = function (start, count) {
        // console.log('dssdfsdfs');
        var mparent2 = this.$model;
        start = start || 0;
        if (count && this.pageSize !== count) {
            // console.log('set pageSize', count);
            this.pageSize = count;
        }
        var end = count;
        if (end === undefined) {
            end = mparent2.length;
        }
        else {
            end += start;
            if (end >= mparent2.length) {
                end = mparent2.length;
            }
        }
        var stime = new Date().getTime();
        var res = [];
        if (true /*usesubitem*/) {
            // const order = this.order;
            var order_1 = this.$getUserData('order', '');
            var nkey = start + "|" + end + "|" + order_1;
            if (nkey === this._internal.cachedKey) {
                // console.log('return cached data', new Date().getTime() - stime);
                return this._internal.cachedItems;
            }
            if (order_1) {
                if (process.env.NODE_ENV === 'development') {
                    console.time("$getItems.order('" + order_1 + "'," + start + "," + end + ")");
                }
                // let stime = new Date().getTime();
                var otable = Array.from(this._internal.ntable);
                otable.sort(function (a, b) { return (mparent2[b.$key][order_1] === mparent2[a.$key][order_1] ? 0 : mparent2[b.$key][order_1] > mparent2[a.$key][order_1] ? -1 : 1); });
                // console.log('order by', (new Date()).getTime() - stime, order, otable[0].$item, ntable[0].$item);
                // tslint:disable-next-line: max-line-length
                // let narray = parent[propName].sort((a: any, b: any) => (b[field] === a[field]) ? 0 : (b[field] > a[field]) ? -1 : 1);
                for (var i = start; i < end; i++) {
                    res.push(otable[i].$item);
                }
                if (process.env.NODE_ENV === 'development') {
                    console.time("$getItems.order('" + order_1 + "'," + start + "," + end + ")");
                }
                // console.log('return ordered data', new Date().getTime() - stime);
            }
            else {
                if (process.env.NODE_ENV === 'development') {
                    console.time("$getItems(" + start + "," + end + ")");
                }
                // console.log('not ordered', ntable[0].$item);
                for (var i = start; i < end; i++) {
                    res.push(this._internal.ntable[i].$item);
                }
                if (process.env.NODE_ENV === 'development') {
                    console.timeEnd("$getItems(" + start + "," + end + ")");
                }
            }
            this._internal.cachedItems = res;
            this._internal.cachedKey = nkey;
            // const aa: any[] = this.$items as WrappedProperty[];
            // console.log("$getItems",start,end,res.length,aa.length);
            // console.log("$getItems", propName, start, end, res.length, (new Date()).getTime() - stime);
            // return res;
            // res = reactivedata.items.slice(start, end).map((x: any) => x.$item);
        }
        else {
            // res = reactivedata.items.slice(start, end);
        }
        // console.log('$getItems.slide', (new Date()).getTime() - stime, res);
        return res;
        // return
    };
    WrappedPropertyArray.prototype.$getPage = function (page, pageSize) {
        if (pageSize === void 0) { pageSize = 25; }
        // console.log('get page');
        return this.$getItems(page * pageSize, pageSize);
    };
    return WrappedPropertyArray;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyArray;
function addRow(self, internal, schitems, rowIndex) {
    // const ssubitem = internal.options.wrapAll ? new WrapperPropertyArrayItemDirect(self, internal.mparent, rowIndex, schitems, internal.options) : new WrapperPropertyArrayItem(self, internal.mparent, rowIndex, schitems, internal.options);
    var ssubitem = new WrappedPropertyArrayItem_1.WrapperPropertyArrayItem(self, internal.mparent, rowIndex, schitems, internal.options);
    internal.ntable.push(ssubitem);
    return ssubitem;
    /*
  
    const ssubitem: any = new Object();
    // const ssubitem: any = { $key: rowIndex };
    // let subitem: any;
  
    Object.defineProperties(ssubitem, {
      $key: {
        writable: true,
        value: rowIndex
      },
  
      $item: {
        get() {
          let subitem = internal.subitemcache[this.$key];
          if (subitem === undefined) {
            subitem = new WrappedPropertyCtor[internal.schema.items.type](self, internal.parent, this.$key, schitems, internal.options);
            this.internal.subitemcache[this.$key] = subitem;
          }
          return subitem;
        }
      }
    });
  
    */
    /*
          if (needCalc) {
            subitemcache[ff] = self.wrapProperty(obj, mparent, ff, schitems);
          }
          */
    internal.ntable.push(ssubitem);
    if (internal.options.wrapAll) {
        var a = ssubitem.$item;
    }
    return ssubitem;
}
function clearCached(internal) {
    // destroy
    for (var i = 0; i < internal.ntable.length; i++) {
        internal.ntable[i].$clearCache();
    }
    /*
    for (let i = 0; i < internal.subitemcache.length; i++) {
      const item = internal.subitemcache[i];
      if (item !== undefined) {
        item.$destroy();
      }
    }
  
    internal.subitemcache = [];
    */
}
// przeliczanie tablicy, calc i aggragate
function recalcArray() {
    return true;
}
WrappedPropertyCtor_1.default.array = WrappedPropertyArray;
//# sourceMappingURL=WrappedPropertyArray.js.map